import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import swal from "sweetalert";
import { removeAuth } from "../../state/authReducer";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#198484",
    },
  },
});

export default function ChangePassword() {
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [Cookie, setCookie, removeCookie] = useCookies(["token"]);
  const dispatch = useDispatch();
  if (Cookie["token"] == null) {
    return <Navigate replace to="/login" />;
  }
  const decoded = jwtDecode(Cookie["token"]);
  const jsonData = JSON.parse(decoded.userInfo);
  if (!jsonData.first_time) {
    return <Navigate replace to="/" />;
  }
  const handleFormSubmit = (ev) => {
    ev.preventDefault();

    if (!password.trim()) {
      swal("Error", "Please Enter New Password", "error");
      return;
    }

    if (!confirmPassword.trim()) {
      swal("Error", "Please Enter Confirm Password", "error");
      return;
    }

    if (password !== confirmPassword) {
      swal(
        "Error",
        "The New Password and Confirm Password don't match",
        "error"
      );
      return;
    }

    const letterCheck = /[A-Za-z]/;
    const numberCheck = /[0-9]/;
    if (
      !letterCheck.test(password) ||
      !numberCheck.test(password) ||
      password.length < 6
    ) {
      swal(
        "Error",
        "Make Sure your password contains at letters, numbers and Length of 6",
        "error"
      );
      return;
    }

    const decoded = jwtDecode(Cookie["token"]);
    const json = JSON.parse(decoded.userInfo);
    const jsonData = {
      id: json.id,
      first_time: false,
      password,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/user/update/" + json.id, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + Cookie["token"],
        "Content-Type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then(async (resp) => {
        const json = await resp.json();
        if (json && json.id) {
          swal(
            "Success",
            "Password Changed Successfully, Log In with the new Password",
            "success",
            {
              buttons: false,
              timer: 2000,
            }
          ).then(() => {
            removeCookie("token");
            dispatch(removeAuth());
          });
        } else {
          swal("Error", resp.data.message, "error");
        }
      })
      .catch((err) => {
        removeCookie("token");
      });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <video
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          minHeight: "100vh",
          minWidth: "100vw",
          zIndex: -2,
        }}
        autoPlay
        loop
        muted
        src="/assets/backgroundVideo.mp4"
      />
      <Box
        sx={{
          background: "#198484",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.6,
          zIndex: -1,
        }}
      />
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          pt: "3rem",
          background: "transparent",
          minWidth: "100vw",
        }}
      >
        <img
          src={"/assets/ZamZamlogowight.webp"}
          alt="ZamZam Logo"
          style={{ height: "100px", width: "400px", marginBottom: "3rem" }}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: 650,
            height: "27rem",
            borderRadius: "1.5rem",
            padding: "1rem 4rem",
            background: "#fff",
            opacity: 1,
            mb: "10rem",
          }}
        >
          <Typography component="h3" variant="h5" color={"#000"}>
          ZamZam Online
          </Typography>
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" color={"#000"}>
            Change Password
          </Typography>
          <Box
            component="form"
            onSubmit={handleFormSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              label="New Password"
              name="newPassword"
              type="password"
              autoComplete="password"
              autoFocus
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Change Password
            </Button>
          </Box>
        </Box>
        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
      </Container>
    </ThemeProvider>
  );
}
